import { t } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@ant-design/pro-components';
import { requirePermission } from '@/features/auth/access';
import { LogViewer } from '@/features/log/viewer';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_authenticated/system/logs')({
  beforeLoad: async ({ context, location }) => {
    await requirePermission(context.queryClient, location.href, 'configs:read');
  },
  component: LogsPage,
});

function LogsPage() {
  useDocumentTitle(t('日志管理'));
  return (
    <PageContainer
      header={{
        title: t('日志管理'),
        subTitle: t('追查操作记录、请求结果与运行异常'),
      }}
    >
      <LogViewer />
    </PageContainer>
  );
}
